import React from "react";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { WagmiProvider } from "wagmi";
import { mainnet, polygon, optimism, arbitrum } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getDefaultConfig } from "@rainbow-me/rainbowkit";

const queryClient = new QueryClient();

const RainbowKitWrapper = ({ children }) => {
  return (
    <WagmiProvider
      config={getDefaultConfig({
        appName: "Bitcoin Live",
        projectId: "b6f3b4f2c501db946650a4dc58928d83",
        chains: [mainnet, polygon, optimism, arbitrum],
        ssr: true,
      })}
    >
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>{children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default RainbowKitWrapper;
